var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 222 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000244141H222L208.566 21.0626C202.798 30.1054 199.914 34.6268 195.422 37.0897C190.93 39.5527 185.567 39.5527 174.842 39.5527H47.1582C36.4325 39.5527 31.0697 39.5527 26.5776 37.0897C22.0855 34.6268 19.2017 30.1054 13.434 21.0626L0 0.000244141Z",
    fill: "url(#paint0_linear_135_12772)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_12772",
    x1: 113.295,
    y1: 39.6117,
    x2: 113.295,
    y2: 9.00284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1C7F68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7D6E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBg);
export default __webpack_public_path__ + "static/media/title_bg.3c508c2562829bd4fa6c836196af53fe.svg";
export { ForwardRef as ReactComponent };